import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('logo-list', {
  onLoad() {
    this.thisSlider = document.querySelector('#logo-list__slider--' + this.id);

    // Reduce slide count by one to align with the 0 positioned slide
    this.logoIndicatorControllers = this.container.querySelector(
      '.controls-container--logo-list'
    );

    if (this.thisSlider) {
      var logoSlider = new Flickity(this.thisSlider, {
        freeScroll: false,
        autoplay: false,
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'center',
        watchCSS: true,
        wrapAround: true,
      });

      const previousButtonLogos = this.logoIndicatorControllers.querySelector(
        '.btn--control__prev'
      );
      previousButtonLogos.addEventListener('click', function() {
        logoSlider.previous();
      });

      const nextButtonLogos = this.logoIndicatorControllers.querySelector(
        '.btn--control__next'
      );
      nextButtonLogos.addEventListener('click', function() {
        logoSlider.next();
      });
    }
  },
});
